<template>
  <section class="content">
      <div class="box box-info">
        <div class="p-toolbar p-component mb-4">
        <billsundrySalesDialog ref="openDialog"/>
      </div>
        <salesExtraExpensesList @delete-message="deleteMessage" @edit-account="editExtraExpenses"/>
      </div>
    </section>
</template>
<script>
import salesExtraExpensesList from './salesExtraExpensesList.vue'
import billsundrySalesDialog from '../billSundryDialog/billSundrySalesDialog.vue'

export default {
  name: 'billsundrysales',
  methods: {
    editExtraExpenses(data) {
      this.$refs.openDialog.editExtraExpenses(data)
    },
    deleteMessage(value) {
      this.$toast.add({severity: value.messageType, summary: '', detail: value.message, life: 10000})
    }
  },
  components: {
    salesExtraExpensesList,
    billsundrySalesDialog
  }
}
</script>



// WEBPACK FOOTER //
// BillSundrySales.vue?3a0c0e2f